import { reactive } from "vue";
import type { FormTargetState, UseFormTargetStore } from "./type";

const stateDefault: FormTargetState = {
  id: undefined,
  formType: undefined,
};

const state = reactive<FormTargetState>({ ...stateDefault });

export function useFormTargetStore(): UseFormTargetStore {
  function setState(values: FormTargetState) {
    Object.assign(state, { ...values });
  }

  function reset(): void {
    Object.assign(state, { ...stateDefault });
  }

  return {
    state,
    setState,
    reset,
  };
}
